import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logout } from "services/session";

export default function useNavbarActions(setIsOpen) {
  const { i18n } = useTranslation();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const handelLogout = logout;

  const changeLng = () => {
    const newLanguage = i18n.language === "ar" ? "en" : "ar";
    localStorage.setItem("default-lg", newLanguage);
    i18n.changeLanguage(newLanguage);
    document.documentElement.setAttribute("lang", newLanguage);
    document.documentElement.setAttribute(
      "dir",
      newLanguage === "ar" ? "rtl" : "ltr"
    );

    const newPath = pathname.replace(/^\/[^/]+/, `/${newLanguage}`);
    navigate(newPath + search);
    window.location.reload();
  };

  const handleSettings = () => {
    setIsOpen(true);
  };

  return { handelLogout, changeLng, handleSettings };
}
